export default import.meta.ROLLDOWN_FILE_URL_Bu$Igw_7AVO2cewv3Xfqbg